import { Grid, Switch } from "@mui/material";
import React, { useState } from "react";
import { AccordionUI } from "../../../../components/commons/acccordion/accordion";

export const EnterpriseSettings = ({ data }: any) => {
  const [checked, setChecked] = useState(data?.is_approve);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };


  return (
    <div>
      <Grid
        container
        spacing={{ xs: 2, md: 3 }}
        columns={{ xs: 4, sm: 8, md: 12 }}
      >
        <Grid item xs={2} sm={4} md={4}>
          <div>
            <b>Nombre de empresa</b>
            <p style={{ marginTop: '8px' }}>{data?.enterprise?.enterprise_name || 'N/A'}</p>
          </div>
        </Grid>
        <Grid item xs={2} sm={4} md={4}>
          <div>
            <b>Correo de empresa</b>
            <p style={{ marginTop: '8px', wordBreak: 'break-all' }}>{data?.email || 'N/A'}</p>
          </div>
        </Grid>
        <Grid item xs={2} sm={4} md={4}>
          <div>
            <b>ID de usuario</b>
            <p style={{ marginTop: '8px', wordBreak: 'break-all' }}>{data?.user || 'N/A'}</p>
          </div>
        </Grid>
        <Grid item xs={2} sm={4} md={4}>
          <div>
            <b>Telefono de empresa</b>
            <p style={{ marginTop: '8px' }}>{data?.enterprise?.enterprise_phone || 'N/A'}</p>
          </div>
        </Grid>
        <Grid item xs={2} sm={4} md={4}>
          <div>
            <b>Fecha de modificación</b>
            <p style={{ marginTop: '8px' }}>
              {data?.updated_at
                ? new Date(data.updated_at).toLocaleDateString("es-MX", {
                    year: "numeric",
                    month: "numeric",
                    day: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                    second: "numeric",
                    timeZone: "America/Mexico_City",
                  })
                : 'N/A'}
            </p>
          </div>
        </Grid>
      </Grid>
      <AccordionUI>
        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
        >
          <Grid item xs={2} sm={4} md={4}>
            <div>
              <b>Estado</b>
              <p style={{ marginTop: '8px' }}>{data?.enterprise?.address?.state || 'N/A'}</p>
            </div>
          </Grid>
          <Grid item xs={2} sm={4} md={4}>
            <div>
              <b>Ciudad</b>
              <p style={{ marginTop: '8px' }}>{data?.enterprise?.address?.city || 'N/A'}</p>
            </div>
          </Grid>
          <Grid item xs={2} sm={4} md={4}>
            <div>
              <b>Calle</b>
              <p style={{ marginTop: '8px' }}>{data?.enterprise?.address?.street || 'N/A'}</p>
            </div>
          </Grid>
          <Grid item xs={2} sm={4} md={4}>
            <div>
              <b>Colonia</b>
              <p style={{ marginTop: '8px' }}>{data?.enterprise?.address?.neighborhood || 'N/A'}</p>
            </div>
          </Grid>
          <Grid item xs={2} sm={4} md={4}>
            <div>
              <b>Numero interior</b>
              <p style={{ marginTop: '8px' }}>{data?.enterprise?.address?.int_number || 'N/A'}</p>
            </div>
          </Grid>
          <Grid item xs={2} sm={4} md={4}>
            <div>
              <b>Numero exterior</b>
              <p style={{ marginTop: '8px' }}>{data?.enterprise?.address?.ext_number || 'N/A'}</p>
            </div>
          </Grid>
        </Grid>
      </AccordionUI>
    </div>
  );
};
